import React, { useState } from "react";

const paletteStyles = {
  aurora: "from-[#312e81]/70 via-[#2563eb]/30 to-[#0f172a]/60",
  ember: "from-[#7c2d12]/70 via-[#f97316]/30 to-[#4c0519]/60",
  neon: "from-[#0f766e]/60 via-[#14b8a6]/30 to-[#0f172a]/70",
  midnight: "from-[#1e1b4b]/70 via-[#4c1d95]/30 to-[#020617]/70",
  moss: "from-[#052e16]/70 via-[#166534]/35 to-[#054a29]/60",
  aurum: "from-[#78350f]/70 via-[#f59e0b]/30 to-[#431407]/70",
};

const testimonials = [
  {
    quote:
      "I highly recommend Satya. He is vastly experienced in data analysis and presenting data into simple visualizations. He helped us with efficient coding in R for most of our data analysis projects and used Tableau for reporting. Satya will be a great asset to any team and organizations looking for data driven decision making.",
    name: "Ram Ravikumar",
    role: "Data Analytics Manager",
    company: "GVSU",
    palette: "aurora",
    swatches: ["#22d3ee", "#a855f7", "#fde68a"],
  },
  {
    quote:
      "Having had the pleasure of working alongside Satya in Infosys. He is someone who goes above and beyond to ensure the success of project deadlines and commitments. I wholeheartedly endorse my colleague Satya and can say any team would be fortunate to have him on board",
    name: "Sweta K",
    role: "Full Stack BI Developer",
    company: "Infosys",
    palette: "ember",
    swatches: ["#fb7185", "#f97316", "#fdba74"],
  },
  {
    quote:
      "I had the pleasure of leading a frontend team where Satya showcased exceptional talent in creating React components and driving feature development for our delivery excellence web app. His dedication to crafting high-quality and user-friendly interfaces significantly contributed to the success of our projects. I highly recommend him for any future endeavours and I believe he will continue to excel in the field of frontend development.",
    name: "Neel Shinde",
    role: "Full Stack Developer",
    company: "Deloitte",
    palette: "neon",
    swatches: ["#6ee7b7", "#34d399", "#a7f3d0"],
  },
  {
    quote:
      "Has been a great team player with extensive knowledge on React JS and overall application Keep doing the good work!",
    name: "Monika Koppula",
    role: "Manager, Full Stack Engineer",
    company: "Deloitte",
    palette: "midnight",
    swatches: ["#c084fc", "#818cf8", "#a5b4fc"],
  },
  {
    quote:
      "I had the pleasure of working with Satya for 1.5 years at Deloitte. He is an excellent developer. He has an impressive ability to effortlessly handle the toughest of situations and this made a huge impact in the productivity level for our project. If 1 get an opportunity, I would definitely want to work with him again. I am sure any employer would be lucky to have him.",
    name: "Gurveen Kaur",
    role: "Java Full Stack Developer",
    company: "Deloitte",
    palette: "neon",
    swatches: ["#67e8f9", "#22d3ee", "#06b6d4"],
  },
  {
    quote:
      "Liked the way he approaches the problem and come up with solutions. Had immense knowledge on React JS and other frontend related technologies. An excellent team person who participates in extra circular activites too and fun to work with.",
    name: "Pavan Kumar Koilada",
    role: "Full Stack Developer",
    company: "Infosys",
    palette: "ember",
    swatches: ["#fde68a", "#f97316", "#ef4444"],
  },
  {
    quote:
      "Satya has a quick learning curve and is able to implement functionalities assigned to him with great vigour. He is also a fun person to be around during breaks and parties.",
    name: "Nikunj Daga",
    role: "UI/UX Solutions Engineer",
    company: "Infosys",
    palette: "aurum",
    swatches: ["#fed7aa", "#fcd34d", "#fbbf24"],
  },
  {
    quote:
      "I am thankful to have know Satya throughout a period of 3 years, he is the most creative and capable software developers. Satya worked on developing software platforms, Ul design, web page design and played a significant role, often, in developing and implementing overall design strategies. His coding was excellent and on point. Satya was coordinating interdepartmentally to facilitate the completion of projects across various IT Domains through full stack development.",
    name: "Santosh Jammi",
    role: "Senior Data Engineer",
    company: "Infosys",
    palette: "midnight",
    swatches: ["#a78bfa", "#f472b6", "#fb7185"],
  },
  {
    quote:
      "This is the person who became a rare combination of colleague and friend for me. Having worked in the same domain we had a great time discussing and learning about latest trends and tech-nologies. He was always committed and easily adjustable to a given situation. Though we have never been in the same project, I would have loved to work with him.",
    name: "Suman Mondal",
    role: "Senior Software Engineer",
    company: "Infosys",
    palette: "moss",
    swatches: ["#bef264", "#84cc16", "#4ade80"],
  },
  {
    quote:
      "I worked with Satya in one of the projects when I was in Infosys..Being a fresher Satya was always ready to take up the new challenges in the Ul/ UX development and always made sure that he does what he is assigned with.. Great experience working with him and all the best for future endeavours !!!",
    name: "Pratyush Kumar",
    role: "Senior Software Engineer",
    company: "Infosys",
    palette: "aurum",
    swatches: ["#fcd34d", "#eab308", "#f97316"],
  },
  {
    quote:
      "I've had the pleasure of working with Satya for almost 2 years. He is very thorough in everything he does and can be depended upon to get the job done. Satya has deep knowledge in Ul technologies and always presented creative solutions to complex problems. He maintains very good relation with his co-workers and clients. Satya is an asset to any organisation and definitely worth recommending.",
    name: "Rana Sarkar",
    role: "Senior Software Engineer",
    company: "Infosys",
    palette: "aurum",
    swatches: ["#fcd34d", "#eab308", "#f97316"],
  },
  {
    quote:
      "A smart developer, a quick learner, Satya always ensured the tasks assigned to him got completed on time. He quickly ramped up on all the Ul skills needed for completing his work.",
    name: "Rakesh Rajpal",
    role: "Project Manager",
    company: "Infosys",
    palette: "aurum",
    swatches: ["#fcd34d", "#eab308", "#f97316"],
  },
];

const rows = [
  { id: "row-1", filter: 0, speed: 50, direction: "left" },
  { id: "row-2", filter: 1, speed: 50, direction: "right" },
];

const CarouselRow = ({ items, speed, direction }) => {
  const [paused, setPaused] = useState(false);

  return (
    <div className="relative overflow-hidden rounded-3xl border border-white/5 bg-white/5 px-2 py-4">
      <div
        className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-r from-[#050507] via-transparent to-[#050507] opacity-20"
        aria-hidden="true"
      />
      <div
        className={`marquee-track ${direction === "right" ? "reverse" : ""}`}
        style={{
          animationDuration: `${speed}s`,
          animationPlayState: paused ? "paused" : "running",
        }}
      >
        {[...items, ...items].map((testimonial, index) => (
          <TestimonialPill
            key={`${testimonial.name}-${index}`}
            testimonial={testimonial}
            onPause={() => setPaused(true)}
            onResume={() => setPaused(false)}
          />
        ))}
      </div>
    </div>
  );
};

const TestimonialPill = ({ testimonial, onPause, onResume }) => {
  const gradient = paletteStyles[testimonial.palette] || paletteStyles.aurora;

  return (
    <article
      className={`min-w-[230px] max-w-[320px] shrink-0 rounded-[28px] border border-white/10 bg-gradient-to-r ${gradient} px-5 py-4 text-left shadow-[0_15px_35px_rgba(0,0,0,0.35)] backdrop-blur-lg`}
      tabIndex={0}
      role="button"
      onClick={() => onPause()}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onPause();
        }
      }}
      onMouseLeave={onResume}
      onPointerLeave={onResume}
      onBlur={onResume}
    >
      <p className="mt-4 text-sm font-medium leading-relaxed text-white/80">
        &ldquo;{testimonial.quote}&rdquo;
      </p>
      <div className="mt-5 text-xs text-white/70">
        <p className="font-semibold text-white">{testimonial.name}</p>
        <p>
          {testimonial.role} · {testimonial.company}
        </p>
      </div>
    </article>
  );
};

const TestimonialsCarousel = () => {
  return (
    <section className="mt-24 rounded-[40px] border border-white/10 bg-[#060608]/80 px-6 py-12 md:px-10">
      <div className="text-center">
        <p className="text-[0.7rem] font-semibold uppercase tracking-[0.4em] text-white/60">
          Testimonials
        </p>
        <h2 className="mt-4 text-3xl font-semibold md:text-4xl">
          Voices from Across the Organization
        </h2>
      </div>

      <div className="mt-10 space-y-6">
        {rows.map((row) => (
          <CarouselRow
            key={row.id}
            items={testimonials.filter((_, index) => index % 3 === row.filter)}
            speed={row.speed}
            direction={row.direction}
          />
        ))}
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
